export const WHATSAPP_NUMBER = "917396897795";

export const waLink = (text) =>
  `https://wa.me/${WHATSAPP_NUMBER}?text=${encodeURIComponent(text)}`;

export const DEFAULT_WA_TEXT =
  "Hi Krystal Skin And Laser Clinic! I'm interested in the ₹22,500 Underarm Laser Hair Reduction Package (10 sessions + annual maintenance). Please share the details.";

export const EMI_WA_TEXT =
  "Hi Krystal Skin And Laser Clinic! I'd like to check no-cost EMI options for the ₹22,500 Underarm Laser Hair Reduction Package.";
